import { render, staticRenderFns } from "./AppContainer.vue?vue&type=template&id=bda22bee&scoped=true"
import script from "./AppContainer.vue?vue&type=script&lang=js"
export * from "./AppContainer.vue?vue&type=script&lang=js"
import style0 from "./AppContainer.scss?vue&type=style&index=0&id=bda22bee&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda22bee",
  null
  
)

export default component.exports